import { Tags } from 'rbh-merchant-core';
import { FoodCategory } from './food-category';

export class FoodMenu {
  menuId?: number;
  menuName?: string;
  menuNameEN?: string;
  menuSKUId?: string;
  menuDescription?: string;
  menuDescriptionEN?: string;
  menuPhoto?: string;
  menuPrice?: number;
  menuStatus?: string;
  menuQCStatus?: string;
  menuQCUpdatedDate?: string;
  menuRejectReason?: [];
  menuCategory?: FoodCategory;
  tagId?: number;
  tag?: Tags;

  constructor(Obj: any = {}) {
    this.menuId = Obj.menuId;
    this.menuName = Obj.menuName;
    this.menuNameEN = Obj.menuNameEN;
    this.menuSKUId = Obj.menuSKUId;
    this.menuDescription = Obj.menuDescription;
    this.menuDescriptionEN = Obj.menuDescriptionEN;
    this.menuPhoto = Obj.menuPhoto;
    this.menuPrice = Obj.menuPrice;
    this.menuStatus = Obj.menuStatus;
    this.menuQCStatus = Obj.menuQCStatus;
    this.menuQCUpdatedDate = Obj.menuQCUpdatedDate;
    this.menuRejectReason = Obj.menuRejectReason;
    this.menuCategory = Obj.menuCategory;
    this.tagId = Obj.tagId;
    this.tag = Obj.tag;
  }
}